import { render, staticRenderFns } from "./EventsSection.vue?vue&type=template&id=b77b32c6&"
import script from "./EventsSection.vue?vue&type=script&lang=js&"
export * from "./EventsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports